import { colors } from "colors"
import { Platform, StyleSheet } from "react-native"

export const style = StyleSheet.create({
  linearGradientContainer: {
    borderBottomEndRadius: 10,
    borderBottomLeftRadius: 10,
    height: 70,
  },
  shadowHeader: {
    borderBottomEndRadius: 10,
    borderBottomLeftRadius: 10,
    height: 70,
    shadowColor: colors.headerShadow,
    shadowOffset: {
      width: 0,
      height: Platform.OS === "web" ? 2 : 3,
    },
    shadowOpacity: 0.5,
    shadowRadius: Platform.OS === "web" ? 10 : 5,
  },
})
